import React from 'react';
import styled from 'styled-components';
import './App.css';

import { BrowserRouter as Router,  Route, Switch, Redirect } from 'react-router-dom'
import {VisitorForm, VisitorPreview, Login, History, Home, NearestBeneficiaries} from './pages'
import * as Cookies from 'js-cookie'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import {API_URL} from './constants'
import get from 'lodash/get'
// import { AddToHome } from './components';
const NotFound = ()=> <h1>NotFound</h1>

const Wrapper = styled.section`
  width: 100%;
  position: relative;
`

const Note = styled.section`
  width: 100%;
  position: fixed;
  height:100%;
  background:#fff2db;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & img{
    width:60%;
  }

`


const PrivateRoute = ({ component: Component, additionalProps, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {

      axios.defaults.baseURL = API_URL
      // axios.defaults.headers.common['Authorization'] = Cookies.get('token');
      // axios.defaults.headers['userid'] = _.get(Cookies.getJSON('user'),'email');

      axios.defaults.withCredentials=true;
      axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';  
      axios.defaults.headers['userid'] =localStorage.getItem("userId")
      
      axios.interceptors.response.use(function (response) {
        // console.log('process.env----------->>>',process.env)
        return response;
      }, function (error) {
        // console.log('------->',get(error, 'response.data.message', ''))
        if(get(error, 'response.data.message.name', '') === 'TokenExpiredError' || get(error, 'response.data.message.name', '') === 'JsonWebTokenError' || get(error, 'response.data.message', '') === 'Access denied'){
          Cookies.remove('token', { path: '/' })
           // localStorage.clear();
        localStorage.removeItem('userId')
        localStorage.removeItem('userData')
          props.history.push("/login");
        }
        return Promise.reject(error);
      });
      
      if (localStorage.getItem("userId")) {
    
        //  axios.get(`${API_URL}/users/checkAuthToken`, {
        //       headers: {
        //         Authorization: 'token'
        //       }
        //     }).catch(err=>{
        //        console.log('==second========>>>',_.get(err, 'response.data.message', ''))
        //       if(_.get(err, 'response.data.message.name', '') === 'TokenExpiredError' || _.get(err, 'response.data.message.name', '') === 'JsonWebTokenError' || _.get(err, 'response.data.message', '') === 'Access denied'){
        //         // Cookies.remove('token', { path: '/' })
        //         // Cookies.remove('userId', { path: '/' })
        //         // Cookies.remove('userData', { path: '/' })
        //         // props.history.push('/login')
        //           Cookies.remove('token', { path: '/' })
        //           localStorage.clear();
        //           props.history.push("/login");
        //       }
        //     })



  // axios.get(`${API_URL}/states`, {
  //             headers: {
  //               Authorization: 'token'
  //             }
  //           }).catch(err=>{
  //              //console.log('==second========>>>',_.get(err, 'response.data.message', ''))
  //             if(_.get(err, 'response.data.message.name', '') === 'TokenExpiredError' || _.get(err, 'response.data.message.name', '') === 'JsonWebTokenError' || _.get(err, 'response.data.message', '') === 'Access denied'){
  //               // Cookies.remove('token', { path: '/' })
  //               // Cookies.remove('userId', { path: '/' })
  //               // Cookies.remove('userData', { path: '/' })
  //               // props.history.push('/login')
  //                 Cookies.remove('token', { path: '/' })
  //                 localStorage.clear();
  //                 props.history.push("/login");
  //             }
  //           })




        return <Component {...props} {...additionalProps} />
      } else {
        // console.log('else--->');
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }

      
    }}
  />
)

const PublicOnlyRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      // check params for access token for google and github signup
      const token = Cookies.get('token')
      if (token) {
        return <Redirect to={{ pathname: '/' }} />
      } else {
        return (
          <Component {...props} />
        )
      }
    }}
  />
)

 function App() {
  axios.defaults.baseURL = API_URL
  // axios.defaults.headers.common['Authorization'] = Cookies.get('token');
  // axios.defaults.headers['userid'] = _.get(Cookies.getJSON('user'),'email');

  axios.defaults.withCredentials=true;
  axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';
  axios.defaults.headers['userid'] = localStorage.getItem('userId') 

  // console.log('---------->>>>', _.get(Cookies.getJSON('user'),'email'))
   axios.get(`/dashboard/permission`).then(res=>{
    //  console.log('async-------->',get(res,'data.data.allowVisitorApp'))
     if(!get(res,'data.data.allowVisitorApp')){
      document.getElementById("chandan").style.display = "flex";
    }
   })


  
return (
<Wrapper>
  <ToastContainer
    autoClose={5000}
    hideProgressBar={true}
    newestOnTop={false}
    closeOnClick={true}
    pauseOnHover={true}
    toastClassName="dark-toast"
  />
   <Note id='chandan' style={{display:'none'}}>
   <img alt='Logo PMAY-U' src={require('./static/logo-2.png')}/> 
    <h5 style={{color:'red'}}>You do not have permission to use Visitor app.</h5>
    </Note>
  {/* <AddToHome /> */}
    <Router basename='/visitor'>
      <Switch>
          <PublicOnlyRoute exact path="/login" component={Login} />
          <Route
            component={(props) => (
              <Switch>
              <PrivateRoute exact path="/" component={Home} />
              <PrivateRoute exact path="/form" component={VisitorForm} />
              <PrivateRoute exact path="/form/:id" component={VisitorForm} />
              <PrivateRoute exact path="/preview" component={VisitorPreview} />
              <PrivateRoute exact path="/history" component={History} />
              <PrivateRoute exact path="/history/:id" component={VisitorPreview} />
              <PrivateRoute exact path="/nearest-beneficiaries" component={NearestBeneficiaries} />
              <PrivateRoute  component={NotFound} />
              </Switch>
            )}
           />
      </Switch>
    </Router>
    </Wrapper>
  );
}

export default App;
